import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { ruRU } from '@mui/material/locale'

const theme = createTheme({},ruRU);
console.log("%c\n\n░██████╗███████╗░█████╗░██╗░░░░░░██████╗\n██╔════╝██╔════╝██╔══██╗██║░░░░░██╔════╝\n╚█████╗░█████╗░░███████║██║░░░░░╚█████╗░\n░╚═══██╗██╔══╝░░██╔══██║██║░░░░░░╚═══██╗\n██████╔╝███████╗██║░░██║███████╗██████╔╝\n╚═════╝░╚══════╝╚═╝░░╚═╝╚══════╝╚═════╝░\n\n", "font-family:monospace;color:#1976d2;font-size:12px;")
createRoot(document.getElementById('root')).render(
    <ThemeProvider theme={theme}>
        <App />
    </ThemeProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

